export const ORDER_STATUS_LABELS = {
  PENDING: 'در انتظار تایید فروشگاه',
  CONFIRMED: 'سفارش ثبت شد',
  PREPARING: 'در مرحله جمع\u200cآوری و ارسال',
  SHIPPED: 'ارسال شد',
  DELIVERED: 'تحویل داده شد',
  CANCELLED: 'لغو شده'
};

export const ORDER_STATUS_LIST = [
  { value: 'PENDING', label: ORDER_STATUS_LABELS.PENDING },
  { value: 'CONFIRMED', label: ORDER_STATUS_LABELS.CONFIRMED },
  { value: 'PREPARING', label: ORDER_STATUS_LABELS.PREPARING },
  { value: 'SHIPPED', label: ORDER_STATUS_LABELS.SHIPPED },
  { value: 'DELIVERED', label: ORDER_STATUS_LABELS.DELIVERED },
  { value: 'CANCELLED', label: ORDER_STATUS_LABELS.CANCELLED }
];

export function getOrderStatusLabel(status) {
  if (!status) return '';
  return ORDER_STATUS_LABELS[status] || status;
}
